// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprQueryVendors extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.query_vendors";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprQueryVendors {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Veure els nostres socis",
                "cs": "Podívejte se na naše partnery",
                "da": "Se vores partnere",
                "de": "Siehe unsere Partner",
                "en": "See our partners",
                "es": "Ver nuestros socios",
                "eu": "Ikusi gure bazkideak",
                "fi": "Katso yhteistyökumppanimme",
                "fr": "Voir nos partenaires",
                "gl": "Consulta os nosos socios",
                "hi": "हमारे साझेदारों को देखें",
                "hu": "Lásd partnereinket",
                "it": "Terze parti",
                "nl": "Bekijk onze leden",
                "no": "Se våre samarbeidspartnere",
                "pl": "Zobacz naszych partnerów",
                "pt": "Veja os nossos parceiros",
                "pt-BR": "Veja nossos parceiros",
                "ro": "Vezi partenerii noștri",
                "ru": "Посмотрите наших партнёров",
                "sk": "Pozrite si našich partnerov",
                "sv": "Se våra partners",
                "tr": "Ortaklarımızı görün"
            },
            "defecto": "See our partners"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
